// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2bjFe","title":"InfoRow_title__3IBwO"};